import { ItemId } from '../../../game/demo/inventory/items';
import { POI_ID } from '../navigator/navigator.model';

// In-memory, per-POI merchant inventory. Each merchant POI holds its own stock,
// filled only by what the player sells to it. Not persisted: resets each session.
export class MerchantStock {
  private readonly byPoi = new Map<POI_ID, Map<ItemId, number>>();

  private stockFor(poi: POI_ID): Map<ItemId, number> {
    let stock = this.byPoi.get(poi);
    if (!stock) {
      stock = new Map();
      this.byPoi.set(poi, stock);
    }
    return stock;
  }

  add(poi: POI_ID, item: ItemId, quantity = 1): void {
    const stock = this.stockFor(poi);
    stock.set(item, (stock.get(item) ?? 0) + quantity);
  }

  remove(poi: POI_ID, item: ItemId, quantity = 1): void {
    const stock = this.stockFor(poi);
    const next = (stock.get(item) ?? 0) - quantity;
    if (next > 0) {
      stock.set(item, next);
    } else {
      stock.delete(item);
    }
  }

  count(poi: POI_ID, item: ItemId): number {
    return this.byPoi.get(poi)?.get(item) ?? 0;
  }

  list(poi: POI_ID): { item: ItemId; quantity: number }[] {
    const stock = this.byPoi.get(poi);
    if (!stock) return [];
    return [...stock.entries()].map(([item, quantity]) => ({ item, quantity }));
  }
}
